export const injectScript = (url, id) => {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;
  script.id = id;
  document.head.appendChild(script);
  return script;
};
